import { Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, Box, Snackbar, Alert, TextField,  Stack,
  Typography} from "@mui/material";
import * as React from "react";
import FileBrowser from "./FileBrowser";
import { get } from 'aws-amplify/api';
import * as ATCAConstants from '../util/ATCAConstants'

export default function CreateFileDialog(
  props: {
    open: boolean,
    handleCreate: (fullfilename: string) => void,
    handleCancel: () => void,
    itemSelectionAllowed: (item: any) => boolean
  }
) {
  const [selectedItem, setSelectedItem] = React.useState<any>(null);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [newName, setNewName] = React.useState<string>('');
  const [projectNameHelper, setProjectNameHelper] = React.useState<string>('');
  const [errorMessage, setErrorMessage] = React.useState<string>('');
  
  React.useEffect(() => {
    setSelectedItem(null);
  }, [props.open]);

  React.useEffect(() => {
    const length = (newName || '').length;
    if (length > ATCAConstants.MAX_NAME_LENGTH) {
      setProjectNameHelper(`Project name has to be less than ${ATCAConstants.MAX_NAME_LENGTH} characters`);
      return;
    }

    const matchName = (((selectedItem||{})['children'])||[]).filter(
      (child: any) => {return child['name'] === newName}
    )
    if (matchName.length > 0) {
      setProjectNameHelper('project name exists already');
    } else {
      setProjectNameHelper('');
    } 
  }, [newName, selectedItem]);


  const handleCancel = () => {
    setSelectedItem(null);
    props.handleCancel();
  }

  const handleCreate = () => {
    const directory = (selectedItem && selectedItem['path']) ? selectedItem['path'] : [];
    let filename = directory.length > 0 ? directory.join('/') + '/' : '';
    filename += selectedItem ? selectedItem['name'] + '/' : '';
    filename += newName;

    if (filename) {
      // get directories from the backend
      const getOperation = get(
        {
          apiName: 'cabb',
          path: '/create_project',
          options: {
            queryParams: {
              project: filename
            }
          }
        }
      );

      getOperation.response
        .then(response => response.body.json())
        .then((response: any) => {
          if (response['status'] === 'fail') {
            setOpenSnack(true);
            setErrorMessage(response['message']);
            props.handleCreate('');
            return;
          }
          props.handleCreate(filename);
        })
        .catch((err: Error) => {
          setOpenSnack(true);
          setErrorMessage(`${err}`);
          props.handleCreate('');
        });
    }
  }

  const canCreateProject = () => {
    return props.itemSelectionAllowed(selectedItem) && newName 
      && !projectNameHelper;
  }

  return (
    <Dialog open={props.open} PaperProps={{ sx: {height: '70%'} }}
      aria-labelledby="create-project-dialog-title"
      onClose={props.handleCancel}
      maxWidth="md" fullWidth>
      <DialogTitle id="create-project-dialog-title">
        Create Project
      </DialogTitle>
      <DialogContent sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}>
        <Stack display={'flex'} flexDirection={'column'}
         paddingTop={'10px'}
         spacing={2} sx={{height: '100%'}}
        >
          <TextField fullWidth id="new-project-name" variant="outlined"
            error={Boolean(projectNameHelper)}
            sx={{height: '100px'}}
            helperText={projectNameHelper}
            label="Name of project to create" 
            value={newName || ''} onChange={(e) => setNewName(e.target.value)} />

          <Typography variant="body2" color={'primary'} gutterBottom>
            Pick a directory for the new project.
          </Typography>
          <Box sx={{height: '100%'}} >
            <FileBrowser open={props.open} paths={null}
              setSelectedItem={setSelectedItem} />
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus 
          disabled={
            !canCreateProject()
          }
          onClick={handleCreate}>
          Create
        </Button>
        <Button onClick={handleCancel}>
          Cancel
        </Button>
      </DialogActions>

      <Snackbar
        role = "alert"
        aria-label = {"Alert message"}
        open={openSnack}
        autoHideDuration={6000}
        onClose={e => setOpenSnack(false)}
      >
        <Alert severity="error">
          Could not create project: {errorMessage}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};
